module.exports = __webpack_public_path__ + "static/media/11.6f8878ad.jpg";